import React from "react";
const ChildDashboard = React.lazy(() =>
  import(/* webpackChunkName: "childDashboard" */ "./childdetail/ChildDashboard/ChildDashboard")
);
const ChildProfile = React.lazy(() =>
  import(/* webpackChunkName: "childProfile" */ "./childdetail/ChildProfile/ChildProfile")
);
//const Enrollment = React.lazy(() =>
//  import(/* webpackChunkName: "enrollment" */ "./childdetail/Enrollment/Enrollment")
//);
const ChildRegister = React.lazy(() =>
  import(/* webpackChunkName: "childRegister2" */ "./childdetail/ChildRegister/ChildRegister")
);
const Billing = React.lazy(() =>
  import(/* webpackChunkName: "billing" */ "./childdetail/Billing/Billing")
);
const DaycareDetails = React.lazy(() =>
  import(/* webpackChunkName: "DaycareDetails" */ "./Daycare/DaycareDetails")
);
const Structure = React.lazy(() =>
  import(/* webpackChunkName: "Structure" */ "./Daycare/Structure/Structure")
);
const ViewSections = React.lazy(() =>
  import(/* webpackChunkName: "ViewSections" */ "./Daycare/ViewSections")
);
const ViewGroups = React.lazy(() =>
  import(/* webpackChunkName: "ViewGroups" */ "./Daycare/ViewGroups")
);
const Presence = React.lazy(() =>
  import(/* webpackChunkName: "Presence" */ "./childdetail/Presence/Presence")
);
//const Prospects = React.lazy(() =>
//  import(/* webpackChunkName: "Prospects" */ "./childdetail/Prospects/Propects")
//);

//const Reports = React.lazy(() =>
//  import(/* webpackChunkName: "Reports" */ "./Daycare/FinancialReporting/Reports")
//); 
const PnL = React.lazy(() =>
  import(/* webpackChunkName: "PnL" */ "./reports/PnL/Finance")
);

const ChildReport = React.lazy(() =>
  import(/* webpackChunkName: "ChildReport" */ "../screens/reporting/childReporting")
);

const DaycareReport = React.lazy(() =>
  import(/* webpackChunkName: "DaycareReport" */ "../screens/reporting/daycareReporting")
);

const AdminDayReport = React.lazy(() =>
  import(/* webpackChunkName: "AdminDayReport" */ "../screens/reporting/adminDayReporting")
);

const ProfessionalReport = React.lazy(() =>
  import(/* webpackChunkName: "ProfessionalReport" */ "../screens/reporting/staffReporting")
);

const ActivityReport = React.lazy(() =>
  import(/* webpackChunkName: "ActivityReport" */ "../screens/reporting/activityReporting")
);

const HomeworkReport = React.lazy(() =>
  import(/* webpackChunkName: "HomeworkReport" */ "../screens/reporting/homeworkReporting")
);

const FinanceReport = React.lazy(() =>
  import(/* webpackChunkName: "FinanceReport" */ "./reports/PnL/Finance")
);

const Child360 = React.lazy(() =>
  import(/* webpackChunkName: "Child360" */ "../screens/reporting/child360")
);

const ChildResults = React.lazy(() =>
  import(/* webpackChunkName: "ChildResults" */ "./childdetail/childResults/ChildResults")
); 

const ChildResultsTemplate = React.lazy(() =>
  import(/* webpackChunkName: "ChildResultsTemplate" */ "./childdetail/childResults/ChildResultsTemplate")
);


// RM: removal of staffmanagement folder from src
//const staffManagement = React.lazy(() =>
//  import(/* webpackChunkName: "staffManagement" */ "../staffmanagement/staffprofileDM")
//);
const PayRoll = React.lazy(() =>
  import(/* webpackChunkName: "payroll" */ "./StaffManagement/PayRoll")
);
const MyDay = React.lazy(() => import(/* webpackChunkName: "MyDay" */ "./Daycare/MyDay/MyDay"));
const profile = React.lazy(() => import(/* webpackChunkName: "profile" */ "./profile"));
const leaveCalendar = React.lazy(() =>
  import(/* webpackChunkName: "leaveCalendar" */ "./StaffManagement/LeaveCalender")
);
const staffProfile = React.lazy(() =>
  import(/* webpackChunkName: "leaveCalendar" */ "./StaffManagement/Profile/Profile")
);
const AICommandCenter = React.lazy(() =>
  import(/* webpackChunkName: "AICommandCenter" */ "./StaffManagement/AICommandCenter/AICommandCenter")
);
const Recruitment = React.lazy(() =>
  import(/* webpackChunkName: "Recruitment" */ "./StaffManagement/Recruitment/Recruitment")
);
const ViewSessions = React.lazy(() =>
  import(/* webpackChunkName: "SessionManagement" */ "./Daycare/ViewSessions")
);
const ViewTerms = React.lazy(() =>
  import(/* webpackChunkName: "TermsManagement" */ "./Daycare/ViewTerms")
);
const AlumniModule = React.lazy(() =>
  import(/* webpackChunkName: "Alumni" */ "./Alumni/AlumniModule")
);
const UserManagement = React.lazy(() =>
  import(/* webpackChunkName: "UserManagement" */ "./Access/UserManagement/UserManagement")
);

const CreateActivity = React.lazy(() =>
  import(/* webpackChunkName: "CreateActivity" */ "./Activities/CreateActivity/CreateActivity")
);
const ManageActivity = React.lazy(() =>
  import(/* webpackChunkName: "ManageActivity" */ "./Activities/ManageActivity/ManageActivity")
);
const Homework = React.lazy(() =>
  import(/* webpackChunkName: "Homework" */ "./Activities/Homework/Homework")
);
const AssessmentTemplate = React.lazy(() =>
  import(/* webpackChunkName: "AssessmentTemplate" */ "./Activities/AssessmentTemplate/AssessmentTemplate")
);

const Milestones = React.lazy(() =>
  import(/* webpackChunkName: "SessionManagement" */ "./Activities/Milestones/Milestones")
);
const Skill = React.lazy(() =>
  import(/* webpackChunkName: "SessionManagement" */ "./Activities/Skill/Skills")
);
const Category = React.lazy(() =>
  import(/* webpackChunkName: "SessionManagement" */ "./Activities/Category/Category")
);

const ParentAccess = React.lazy(() =>
  import(/* webpackChunkName: "LiveDashboard" */ "./Access/parentAccess/ParentAccess")
);
const StudentAccess = React.lazy(() =>
  import(/* webpackChunkName: "StudentAccess" */ "./Access/studentAccess/StudentAccess")
);
const DriverAccess = React.lazy(() =>
  import(/* webpackChunkName: "DriverAccess" */ "./Access/driverAccess/DriverAccess")
);

//const LiveDashboard = React.lazy(() =>
//  import(/* webpackChunkName: "LiveDashboard" */ "./Live/LiveDashboard")
//);

const CreateMenu = React.lazy(() =>
  import(/* webpackChunkName: "CreateMenu" */ "./MealManagement/CreateMenu")
);

const MealPlan = React.lazy(() =>
  import(/* webpackChunkName: "MealPlan" */ "./MealManagement/MealPlan/MealPlan")
);

const EnrollmentNew = React.lazy(() =>
  import(/* webpackChunkName: "EnrollmentNew" */ "./Leads/Enrollment/Enrollment")
);

const ProspectsNew = React.lazy(() =>
  import(/* webpackChunkName: "ProspectsNew" */ "./Leads/Prospects/Propects")
);


//const WebEnquires = React.lazy(() =>
//  import(/* webpackChunkName: "ProspectsNew" */ "./Leads/Prospects/Propects")
//);

const SurveyParents = React.lazy(() =>
  import(/* webpackChunkName: "ProspectsNew" */ "./Leads/Survey/Survey")
);

const WebsiteMgt = React.lazy(() =>
  import(/* webpackChunkName: "ProspectsNew" */ "./Leads/Website/Website")
);

const lazyTransportationPage = (exportName) =>
  React.lazy(() =>
    import(
      /* webpackChunkName: "Transportation" */ "./Transportation/TransportationPlaceholder"
    ).then((module) => ({ default: module[exportName] }))
  );

const TransportationOverview = React.lazy(() =>
  import(/* webpackChunkName: "TransportationOverview" */ "./Transportation/Overview/Overview")
);
const TransportationTrips = React.lazy(() =>
  import(/* webpackChunkName: "TransportationTrips" */ "./Transportation/Trips/Trips")
);
const TransportationRoutes = React.lazy(() =>
  import(/* webpackChunkName: "TransportationRoutes" */ "./Transportation/Routes/Routes")
);
const TransportationStops = React.lazy(() =>
  import(/* webpackChunkName: "TransportationStops" */ "./Transportation/Stops/Stops")
);
const TransportationStudents = React.lazy(() =>
  import(/* webpackChunkName: "TransportationStudents" */ "./Transportation/Students/Students")
);
const TransportationVehicles = React.lazy(() =>
  import(/* webpackChunkName: "TransportationVehicles" */ "./Transportation/Vehicles/Vehicles")
);
const TransportationStaff = React.lazy(() =>
  import(/* webpackChunkName: "TransportationStaff" */ "./Transportation/Staff/Staff")
);
const TransportationVendors = React.lazy(() =>
  import(/* webpackChunkName: "TransportationVendors" */ "./Transportation/Vendors/Vendors")
);
const TransportationSettings = React.lazy(() =>
  import(/* webpackChunkName: "TransportationSettings" */ "./Transportation/Settings/Settings")
);
const TimetableOverview = React.lazy(() =>
  import(/* webpackChunkName: "TimetableOverview" */ "./Timetable/Overview/Overview")
);
const TimetableBuilder = React.lazy(() =>
  import(/* webpackChunkName: "TimetableBuilder" */ "./Timetable/Builder/TimetableBuilder")
);
const BellSchedules = React.lazy(() =>
  import(/* webpackChunkName: "BellSchedules" */ "./Timetable/BellSchedules/BellSchedules")
);
const TimetableRooms = React.lazy(() =>
  import(/* webpackChunkName: "TimetableRooms" */ "./Timetable/Rooms/Rooms")
);
const TeacherScheduling = React.lazy(() =>
  import(/* webpackChunkName: "TeacherScheduling" */ "./Timetable/TeacherScheduling/TeacherScheduling")
);
const LearningGroups = React.lazy(() =>
  import(/* webpackChunkName: "LearningGroups" */ "./Timetable/LearningGroups/LearningGroups")
);
const TeachingRequirements = React.lazy(() =>
  import(/* webpackChunkName: "TeachingRequirements" */ "./Timetable/TeachingRequirements/TeachingRequirements")
);
const ParallelBlocks = React.lazy(() =>
  import(/* webpackChunkName: "ParallelBlocks" */ "./Timetable/ParallelBlocks/ParallelBlocks")
);
const PublishVersions = React.lazy(() =>
  import(/* webpackChunkName: "PublishVersions" */ "./Timetable/PublishVersions/PublishVersions")
);
const ManagementOverview = React.lazy(() =>
  import(/* webpackChunkName: "ManagementOverview" */ "./Timetable/ManagementOverview/ManagementOverview")
);
const MyTimetable = React.lazy(() =>
  import(/* webpackChunkName: "MyTimetable" */ "./Timetable/PublishedTimetable/MyTimetable")
);
const DailyOperations = React.lazy(() =>
  import(/* webpackChunkName: "DailyOperations" */ "./Timetable/DailyOperations/DailyOperations")
);
const OperationalPlanning = React.lazy(() =>
  import(/* webpackChunkName: "OperationalPlanning" */ "./Timetable/OperationalPlanning/OperationalPlanning")
);
const ExaminationOperations = React.lazy(() =>
  import(/* webpackChunkName: "ExaminationOperations" */ "./Timetable/Examinations/ExaminationOperations")
);

//const WebVisitors = React.lazy(() =>
//  import(/* webpackChunkName: "ProspectsNew" */ "./Leads/Prospects/Propects")
//);


//const Finance = React.lazy(() => import("./Daycare/Finance"));
export const subModuleData = {
  childManagement: [
    {
      name: "childDashboard",
      group: "Admissions",
      url: "/childManagement/childDashboard",
      component: "ChildDashboard",
    },
    {
      name: "childProfile",
      group: "Admissions",
      url: "/childManagement/childProfile",
      component: "ChildProfile",
    },
    {
      name: "enrollment",
      url: "/childManagement/enrollment",
      component: "EnrollmentNew",
      group: "Admissions",
      icon: "app_registration",
    },
    {
      name: "prospects",
      url: "/childManagement/prospects",
      component: "ProspectsNew",
      group: "Admissions",
      icon: "contact_page",
    },
    {
      name: "registerChild",
      group: "Admissions",
      url: "/childManagement/childRegister",
      component: "ChildRegister",
    },
    {
      name: "alumni",
      group: "Admissions",
      url: "/childManagement/alumni",
      component: "AlumniModule",
      icon: "school",
    },
    {
      name: "billing",
      group: "Operations",
      url: "/childManagement/billing",
      component: "Billing",
    },
    {
      name: "presence",
      group: "Operations",
      url: "/childManagement/presence",
      component: "Presence",
    },
    {
      name: "child360",
      group: "Reports",
      url: "/childManagement/child360",
      component: "Child360",
      icon: "360",
    },
    {
      name: "childresults",
      group: "Reports",
      url: "/childManagement/results",
      component: "ChildResults",
      icon: "radar",
    },
    {
      name: "childresultstemplate",
      group: "Reports",
      url: "/childManagement/resultstemplate",
      component: "ChildResultsTemplate",
      icon: "view_quilt",
    },
  ],
  daycare: [
    {
      name: "daycareDetails",
      group: "Info",
      url: "/myDaycareNew/details",
      component: "DaycareDetails",
    },
    {
      name: "structure",
      group: "Structure",
      url: "/myDaycareNew/structure",
      component: "Structure",
      icon: "account_tree",
    },
    {
      name: "sections",
      group: "Structure",
      url: "/myDaycareNew/sections",
      component: "ViewSections",
    },
    {
      name: "groups",
      group: "Structure",
      url: "/myDaycareNew/groups",
      component: "ViewGroups",
    },
    {
      name: "learningGroups",
      group: "Structure",
      url: "/myDaycareNew/learning-groups",
      component: "LearningGroups",
      icon: "groups",
    },
  //  {
  //    name: "reports",
  //    url: "/myDaycareNew/reports",
  //    component: "Reports",
  //  },
    {
      name: "myDay",
      group: "Operations",
      url: "/myDaycareNew/myday",
      component: "MyDay",
    },
    {
      name: "sessions",
      group: "Academic period",
      url: "/myDaycareNew/viewSessions",
      component: "ViewSessions",
    },
    {
      name: "terms",
      group: "Academic period",
      url: "/myDaycareNew/viewTerms",
      component: "ViewTerms",
    },
    {
      name: "surveys",
      group: "Marketing",
      url: "/myDaycareNew/survey",
      component: "SurveyParents",
      icon: "groups",
    },
  //  {
  //    name: "finance",
  //    url: "/myDaycareNew/finance",
  //    component: "Finance",
   // },
   //original code
   // {
   //   name: "userManagement",
   //   url: "/myDaycareNew/userManagement",
   //   component: "UserManagement",
  //  },
  ],
  staffManagement: [
    { name: "profiles", group: "Info", url: "/staffmanagement/profile", component: "staffProfile" },
    { name: "myTimetable", group: "Operations", url: "/staffmanagement/my-timetable", component: "MyTimetable", icon: "event_note" },
    { name: "payroll", group: "Operations", url: "/staffmanagement/payroll", component: "payRoll" },
    { name: "leaveCalendar", group: "Operations", url: "/staffmanagement/leavecalendar", component: "leaveCalendar" },
    {
      name: "aiCommandCenter",
      group: "Augmentation",
      url: "/staffmanagement/ai-command-center",
      component: "AICommandCenter",
      icon: "auto_awesome",
    },
    {
      name: "recruitment",
      group: "Recruitment",
      url: "/staffmanagement/recruitment",
      component: "Recruitment",
      icon: "work",
    },
  ],
 
  reports: [
    {
      name: "adminDayReport",
      group: "Overview",
      url: "/reports/adminDayReport",
      component: "AdminDayReport",
      //icon: "auto_awesome",
    },
    {
      name: "pnl",
      group: "Financial",
      url: "/reports/pnl",
      component: "PnL",
    },
    {
      name: "financeReport",
      group: "Financial",
      url: "/reports/financeReport",
      component: "FinanceReport",
    },
    // {
    //   name: "childReport",
    //   url: "/reports/childReport",
    //   component: "ChildReport",
    // },
    {
      name: "daycareReport",
      group: "School & Staff",
      url: "/reports/daycareReport",
      component: "DaycareReport",
    },
    {
      name: "professionalReport",
      group: "School & Staff",
      url: "/reports/professionalReport",
      component: "ProfessionalReport",
    },
    { name: "managementOverview", group: "School & Staff", url: "/timetable/management-overview", component: "ManagementOverview", icon: "assessment" },
    {
      name: "activityReport",
      group: "Learning",
      url: "/reports/activityReport",
      component: "ActivityReport",
    },
    {
      name: "homeworkReport",
      group: "Learning",
      url: "/reports/homeworkReport",
      component: "HomeworkReport",
      icon: "assignment_turned_in",
    },
  ],
  activities: [
    {
      name: "manageActivities",
      group: "Planning",
      url: "/activity/manage",
      component: "ManageActivity",
    },
    {
      name: "homework",
      group: "Planning",
      url: "/activity/homework",
      component: "Homework",
      icon: "assignment",
    },
    {
      name: "createActivities",
      group: "Curriculum library",
      url: "/activity/create",
      component: "CreateActivity",
    },
   
    {
      name: "milestones",
      group: "Curriculum library",
      url: "/activity/milestones",
      component: "Milestones",
    },
    {
      name: "category",
      group: "Curriculum library",
      url: "/activity/category",
      component: "Category",
      icon: "category",
    },
    {
      name: "skills",
      group: "Curriculum library",
      url: "/activity/skills",
      component: "Skills",
      icon: "psychology",
    },
    {
      name: "assessmentTemplate",
      group: "Assessment",
      url: "/activity/assessment-template",
      component: "AssessmentTemplate",
      icon: "rule",
    },
   
  ],
  access: [
    {
      name: "userManagement",
      group: "Access",
      url: "/access/userManagement",
      component: "UserManagement",
    },
    {
      name: "parentAccess",
      group: "Access",
      url: "/access/parentAccess",
      component: "ParentAccess",
    },
    {
      name: "studentAccess",
      group: "Access",
      url: "/access/studentAccess",
      component: "StudentAccess",
      icon: "school",
    },
    {
      name: "driverAccess",
      group: "Access",
      url: "/access/driverAccess",
      component: "DriverAccess",
      icon: "directions_bus",
    },
  ],

  leads: [
    {
      name: "website",
      url: "/leads/website",
      component: "WebsiteMgt",
    },

    

 /*   {
      name: "webenqueries",
      url: "/leads/prospects",
      component: "WebEnqueries",
    },
*/
    
/*
    {
      name: "webvisitors",
      url: "/leads/prospects",
      component: "WebVisitors",
    }, */
  ],

  transportation: [
    {
      name: "overview",
      url: "/transportation/overview",
      component: "TransportationOverview",
      icon: "dashboard",
    },
    {
      name: "trips",
      group: "Operations",
      url: "/transportation/operations/trips",
      component: "TransportationTrips",
      icon: "departure_board",
    },
    {
      name: "routes",
      group: "Planning",
      url: "/transportation/planning/routes",
      component: "TransportationRoutes",
      icon: "route",
    },
    {
      name: "stops",
      group: "Planning",
      url: "/transportation/planning/stops",
      component: "TransportationStops",
      icon: "location_on",
    },
    {
      name: "students",
      group: "Planning",
      url: "/transportation/planning/students",
      component: "TransportationStudents",
      icon: "school",
    },
    {
      name: "vehicles",
      group: "Resources",
      url: "/transportation/resources/vehicles",
      component: "TransportationVehicles",
      icon: "directions_bus",
    },
    {
      name: "transportStaff",
      group: "Resources",
      url: "/transportation/resources/staff",
      component: "TransportationStaff",
      icon: "badge",
    },
    {
      name: "vendors",
      group: "Resources",
      url: "/transportation/resources/vendors",
      component: "TransportationVendors",
      icon: "business",
    },
    {
      name: "settings",
      dividerBefore: true,
      url: "/transportation/settings",
      component: "TransportationSettings",
      icon: "settings",
    },
  ],

  timetable: [
    { name: "overview", url: "/timetable/overview", component: "TimetableOverview", icon: "dashboard" },
    { name: "dailyOperations", url: "/timetable/daily-operations", component: "DailyOperations", icon: "today" },
    { name: "bellSchedules", group: "Setup", url: "/timetable/bell-schedules", component: "BellSchedules", icon: "schedule" },
    { name: "rooms", group: "Setup", url: "/timetable/rooms", component: "TimetableRooms", icon: "meeting_room" },
    { name: "teacherScheduling", group: "Setup", url: "/timetable/teacher-scheduling", component: "TeacherScheduling", icon: "co_present" },
    { name: "teachingRequirements", group: "Planning", url: "/timetable/teaching-requirements", component: "TeachingRequirements", icon: "fact_check" },
    { name: "parallelBlocks", group: "Planning", url: "/timetable/parallel-blocks", component: "ParallelBlocks", icon: "splitscreen" },
    { name: "timetableBuilder", group: "Build & publish", url: "/timetable/builder", component: "TimetableBuilder", icon: "calendar_view_week" },
    { name: "publishVersions", group: "Build & publish", url: "/timetable/publish-versions", component: "PublishVersions", icon: "publish" },
  ],
  examsEvents: [
    { name: "operationalPlanning", url: "/timetable/operational-planning", component: "OperationalPlanning", icon: "dashboard" },
    { name: "examinations", url: "/timetable/examinations", component: "ExaminationOperations", icon: "quiz" },
    { name: "eventsDuties", url: "/timetable/events-duties", component: "OperationalPlanning", icon: "event_available" },
  ],

   mealManagement: [
     {
      name: "mealPlan",
      url: "/mealmanagement/mealplan",
      component: "MealPlan",
    },
    {
      name: "createMenu",
      url: "/mealmanagement/createmenu",
      component: "CreateMenu",
    },
  
  ],
  /*
  live: [
    {
      name: "liveStream",
      url: "/live",
      component: "LiveDashboard",
    },
  ],

  mealManagement: [
    {
      name: "createMenu",
      url: "/mealmanagement/createmenu",
      component: "CreateMenu",
    },
   
  ],*/

};

export const components = {
  ChildDashboard: ChildDashboard,
  ChildProfile: ChildProfile,
  //Enrollment: Enrollment,// moved enrollment under leads
  ChildRegister: ChildRegister,
  Billing: Billing,
  Presence: Presence,
  //Prospects: Prospects, // moved prospects under leads
  DaycareDetails: DaycareDetails,
  ViewSections: ViewSections,
  ViewGroups: ViewGroups,
  //Reports: Reports,
  Structure: Structure,
  MyDay: MyDay,
  ViewSessions: ViewSessions,
  ViewTerms: ViewTerms,
  AlumniModule: AlumniModule,
  //Finance: Finance,
  // RM removal of staffnamanegement from src folder
  //staffManagement: staffManagement,
  
  AdminDayReport: AdminDayReport,
  PnL: PnL,
  // ChildReport: ChildReport,
  DaycareReport: DaycareReport,
  ProfessionalReport: ProfessionalReport,
  ActivityReport: ActivityReport,
  HomeworkReport: HomeworkReport,
  FinanceReport: FinanceReport,
  Child360: Child360,
  ChildResults: ChildResults,
  ChildResultsTemplate: ChildResultsTemplate,
  payRoll: PayRoll,
  leaveCalendar: leaveCalendar,
  staffProfile: staffProfile,
  AICommandCenter: AICommandCenter,
  Recruitment: Recruitment,
  TransportationOverview: TransportationOverview,
  TransportationTrips: TransportationTrips,
  TransportationRoutes: TransportationRoutes,
  TransportationStops: TransportationStops,
  TransportationStudents: TransportationStudents,
  TransportationVehicles: TransportationVehicles,
  TransportationStaff: TransportationStaff,
  TransportationVendors: TransportationVendors,
  TransportationSettings: TransportationSettings,
  TimetableOverview: TimetableOverview,
  TimetableBuilder: TimetableBuilder,
  BellSchedules: BellSchedules,
  TimetableRooms: TimetableRooms,
  TeacherScheduling: TeacherScheduling,
  LearningGroups: LearningGroups,
  TeachingRequirements: TeachingRequirements,
  ParallelBlocks: ParallelBlocks,
  PublishVersions: PublishVersions,
  ManagementOverview: ManagementOverview,
  MyTimetable: MyTimetable,
  DailyOperations: DailyOperations,
  OperationalPlanning: OperationalPlanning,
  ExaminationOperations: ExaminationOperations,
  UserManagement: UserManagement,

  CreateActivity: CreateActivity,
  ManageActivity: ManageActivity,
  Homework: Homework,
  AssessmentTemplate: AssessmentTemplate,
  Milestones: Milestones,
  Category: Category,
  Skills: Skill,
  ParentAccess: ParentAccess,
  StudentAccess: StudentAccess,
  DriverAccess: DriverAccess,
  EnrollmentNew: EnrollmentNew,
  ProspectsNew: ProspectsNew,
  //WebEnquires: WebEnquires,
  SurveyParents: SurveyParents,
  WebsiteMgt: WebsiteMgt,
  //WebVisitors: WebVisitors,
  //LiveDashboard: LiveDashboard,
  CreateMenu: CreateMenu,
  MealPlan: MealPlan,
 

};
